import { createFileRoute } from '@tanstack/react-router';
import { CampaignsListRouteView } from '@/pages/workspaces/automations/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The Automations list. No `appBundle`: this URL has no `journeys` segment for the resolver to
 * rebuild from.
 */
function AutomationsIndexRoute() {
  return (
    <LastWorkspaceResolver>
      <CampaignsListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/')({
  component: AutomationsIndexRoute,
});
